<template>
    <div class="container chart-wrapper pt-3 pb-3">
        <vue-skeleton-loader
            type="rec"
            :width="width"
            :height="height"
            animation="fade"
        />
    </div>
</template>
<script>
import VueSkeletonLoader from 'skeleton-loader-vue';

export default {
  name: "ChartDisplaySkeleton",
  mixins: [],
  components: {VueSkeletonLoader},
  data() {
    return {};
  },    
  props: {
    width: { type: Number, default: 1118 },
    height: { type: Number, default: 1140 }
  },
  methods: {},
  computed: {}, 
  created() {},
  mounted() {},
};

</script>
